import {get} from 'lodash';
import schema from './notification_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import moment from 'moment';
import debug from '../debug';

export function title(model) {
  return i18n.S(get(model, 'details.title'), i18n.s('schema.notification'));
}

export const columns = utils.columnsFn(schema);
export const list = utils.listFn('getAdminNotifications');
export const view = utils.viewFn('/admin/notifications/:id');
export const read = utils.readFn('getNotificationById', 'notification_id');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  let read = get(model, 'read');
  temp.push({
    label: read ? i18n.fr('action.unread') : i18n.fr('action.read'),
    class: 'btn-success',
    action: utils.updateFn(
      'updateNotificationByIds',
      null,
      null,
      (payload) => {
        payload.notification_ids = [payload.notification_id];
        payload.read = !read;
        return payload;
      },
      null,
      utils.formActions.postprocess.redirect(() => '/admin/notifications')),
  });
  if (debug.DEBUG) {
    temp.push({
      label: i18n.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: e => e.keyCode === 46,
      action: utils.formActions.delete('deleteNotificationById', 'notification_id', '/admin/notifications'),
    });
  }
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateNotificationByIds', 'notification_ids', [
        'status',
        'read',
      ]),
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/notification.js